import { OnInit, Component, Input, ViewEncapsulation } from '@angular/core';
import * as bowser from 'bowser';
@Component({
	selector: 'submission-preloader-popup',
	template: `
		<div class="submission-loader-modal-backdrop"></div>
		<div class="submission-loader-modal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="image-spinner">
						<img
							[ngClass]="{ 'plymouth-rock-logo': modal.data.logo.indexOf('PlymouthRock') !== -1 }"
							src="{{ modal.data.logo }}"
						/>
						<div class="loader-spinner"></div>
						<div class="shadow"></div>
					</div>
					<div class="labels">
						<h1>{{ modal.data.title }}</h1>
						<p class="subtitle">{{ modal.data.subtitle }}</p>
						<p class="subtitle2">{{ modal.data.secondSubtitle }}</p>
					</div>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./submission-preloader-popup.component.scss'],
})
export class SubmissionPreloaderPopupComponent implements OnInit {
	currentImageIndex: any;
	@Input() closeModal;
	@Input() modalRef;
	@Input() modal: any;

	constructor() {}

	ngOnInit() {
		if (this.modal.data) {
			setTimeout(() => {
				var modalElem = document.getElementsByClassName('submission-loader-modal')[0];

				const isMobile =
					bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
					bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
				if (isMobile) {
					modalElem.classList.add('mobile');
				}
			}, 0);
		}
	}

	close() {
		this.closeModal();
	}
}
